module.exports = __webpack_public_path__ + "static/img/detail-meetingD.c016d4f0.png";